import { useSyncExternalStore } from 'react';

// One clock for every relative timestamp on the page. A label like "59m ago" is only
// true when it is drawn; threads and lists stay open for hours, so the label has to be
// redrawn as time passes -- and across midnight, when "Today" becomes "Yesterday".
//
// A single timer serves every subscriber, and only while there is one: a page of 500
// timestamps adds one interval, not 500. Static timestamps (audit logs, exports) never
// change, so they do not subscribe at all.

export const TICK_MS = 30 * 1000;

const listeners = new Set();
let timer = null;
let tick = 0;

function subscribe(listener) {
  listeners.add(listener);
  if (timer === null) {
    timer = setInterval(() => {
      tick += 1;
      listeners.forEach((l) => l());
    }, TICK_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== null) {
      clearInterval(timer);
      timer = null;
    }
  };
}

const getTick = () => tick;
const noSubscription = () => () => {};
const noTick = () => 0;

// Re-renders the caller on every tick while `live` is true. The value returned is only
// a counter; the time itself is read wherever it is used.
export function useNow(live = true) {
  return useSyncExternalStore(live ? subscribe : noSubscription, live ? getTick : noTick);
}

// For tests: how many components are listening, and whether the shared timer runs.
export function clockState() {
  return { listeners: listeners.size, running: timer !== null };
}
